import type { GridProps } from '@chakra-ui/react'
import { forwardRef, Grid } from '@chakra-ui/react'
import { useState } from 'react'
import type { CompanyLogoProps } from '../CompanyLogo'
import { RecapExtraHeader } from './RecapExtraHeader'

export interface RecapExtraProps extends GridProps {
  logoProps?: CompanyLogoProps
}

export const RecapExtra = forwardRef(({ children, logoProps, sx, ...rest }: RecapExtraProps, ref,) => {
  const [isEnabled, setIsEnabled] = useState(true)

  const handleStatusChange = () => {
    setIsEnabled(!isEnabled)
  }

  return (
    <Grid ref={ref} sx={{ ...sx }} {...rest}>
      <RecapExtraHeader
        logoProps={logoProps}
        isEnabled={isEnabled}
        onStatusChange={handleStatusChange}
      />

      <Grid sx={{ gap: 0.5 }}>{children}</Grid>
    </Grid>
  )
},
)
